import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';
import CustomAvailability from './CustomAvailability';

const CalendarView = observer(class CalendarView extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.calc = this.calc.bind(this);
    this.today = this.today.bind(this);
    this.prevMonth = this.prevMonth.bind(this);
    this.nextMonth = this.nextMonth.bind(this);
    this.renderAvailabilityList = this.renderAvailabilityList.bind(this);

    this.state = {
      today: moment().startOf('day'),
      year: moment().year(),
      month: moment().month(),
      startDay: 1,
      disablePast: false,
      firstOfMonth: new Date(moment().year(), moment().month(), 1),
      daysInMonth: new Date(moment().year(), moment().month() + 1, 0).getDate(),
      timeZone: ''
    }
  }

  componentDidMount() {
    const _this = this;
    const { LocationStore, ScheduleStore, SessionStore } = this.props.store;
    let timeZoneSid = '';

    if (LocationStore.locations && LocationStore.locations.length > 0) {
      const location = LocationStore.locations.find(location => location.sid === this.props.locationSid);
      timeZoneSid = location.timeZoneSid;
    }

    // Set the intial state


    // Get the calendar’s availability
    const callback = () => {
      _this.getAvailability();

      // Disabling exclusions until a later date
      // ScheduleStore.getExclusions(data.schedule.sid);
    }

    const timeZoneCallback = (timeZones) => {
      const timezoneObj = timeZones.find(result => result.sid === timeZoneSid);
      if (timezoneObj && timezoneObj.name) {
        this.setState({timeZone: moment.tz(timezoneObj.name).format('z')});
      }
    }

    ScheduleStore.getCalendar(this.props.locationSid, this.props.calendarSid, callback);
    SessionStore.getTimezones(timeZoneCallback);
  }
  renderAvailabilityList(){
    const { ScheduleStore } = this.props.store;

    let baseAvailabilities = ScheduleStore.availabilities[moment(this.state.editAvailabilityDate).format('YYYY-MM-DD')]
    let availabilities = null;
    if (baseAvailabilities) {

      baseAvailabilities = baseAvailabilities.filter(obj => {
        return !obj.excludeDate;
      });

      availabilities = baseAvailabilities.filter(obj => {
        return obj.override === true;
      })

      if(availabilities.length === 0){
        availabilities = baseAvailabilities;
      }
    }

    console.log('baseAvailabilities:', baseAvailabilities);

    this.setState({cleanedAvailabilities: availabilities})
  }

  getAvailability() {
    const { ScheduleStore } = this.props.store;

    let month = parseInt(this.state.month, 10) + 1;

    if(month < 10) {
      month = '0' + month;
    }

    const startDate = `${this.state.year}-${month}-01`;
    const endDate = `${this.state.year}-${month}-${this.state.daysInMonth}`;

    const callback = () => {
      if(this.state.editAvailabilityDate){
        this.renderAvailabilityList();
      }
    }

    ScheduleStore.getAvailability(this.props.calendarSid, startDate, endDate, callback);
  }

  calc(year, month) {
    return {
      firstOfMonth: new Date(year, month, 1),
      daysInMonth: new Date(year, month + 1, 0).getDate()
    }
  }

  today() {
    const _this = this;

    let state = {};
    state.year = moment().year();
    state.month = moment().month();

    Object.assign(state, this.calc.call(null, state.year, state.month));
    this.setState(state);

    setTimeout(function(){
      _this.getAvailability();
    });
  }

  prevMonth() {
    const _this = this;

    let state = {};

    if(this.state.month > 0) {
      state.month = this.state.month - 1;
      state.year = this.state.year;
    } else {
      state.month = 11;
      state.year = this.state.year - 1;
    }

    Object.assign(state, this.calc.call(null, state.year, state.month));
    this.setState(state);

    setTimeout(function(){
      _this.getAvailability();
    });
  }

  nextMonth() {
    const _this = this;

    let state = {};

    if(this.state.month < 11) {
      state.month = this.state.month + 1;
      state.year = this.state.year;
    } else {
      state.month = 0;
      state.year = this.state.year + 1;
    }

    Object.assign(state, this.calc.call(null, state.year, state.month));
    this.setState(state);

    setTimeout(function(){
      _this.getAvailability();
    });
  }

  renderAvailabilities(date, dayOfWeek, past) {
    const { translation } = this.props;
    const { ScheduleStore } = this.props.store;
    const { availabilities } = ScheduleStore;
    // Add leading zeroes to dates
    let month = this.state.month + 1;

    if(month < 10) {
      month = '0' + month;
    }

    let dayOfMonth = date;

    if(dayOfMonth < 10) {
      dayOfMonth = '0' + dayOfMonth;
    }

    // Format the date
    const formattedDate = `${this.state.year}-${month}-${dayOfMonth}`;

    // Render the list
    if(availabilities[formattedDate]) {
      let cleanedAvailabilities = [];

      let baseAvailabilities = availabilities[formattedDate];

      baseAvailabilities = baseAvailabilities.filter(obj => {
        return !obj.excludeDate;
      });

      cleanedAvailabilities = baseAvailabilities.filter(obj => {
        return obj.override === true;
      });
      if(cleanedAvailabilities.length === 0){
        cleanedAvailabilities = baseAvailabilities;
      }




      return (
        <div>
          <ol className="calendar__slots">
            {cleanedAvailabilities.map((key, i) => {
              if(!key.hide) {
                return (
                  <li key={i} className="calendar-slot-item">
                    {moment(key.startTime, 'HH:mm:ss').format('h:mma')}–
                    {moment(key.endTime, 'HH:mm:ss').format('h:mma')}

                    {key.effectiveNumberOfSeats &&
                      <div>
                        {this.props.translation.capacity} {key.effectiveNumberOfSeats}
                      </div>
                    }

                  </li>

                )
              }

              return null;
            })}
          </ol>

          {!past &&
            <button
              onClick={() => this.editAvailability(date, dayOfWeek)}
            >
              <span className="meta">
                {translation.edit_date.replace(
                  '%date%', `${this.state.year}-${this.state.month}-${date}`
                )}
              </span>
            </button>
          }
        </div>
      )
    }

    return null;
  }


  editAvailability(date, dayOfWeek) {
    const formattedDate = moment(`${this.state.year}-${this.state.month + 1}-${date}`, 'YYYY-MM-DD');

    this.setState({
      editAvailability: true,
      editAvailabilityDate: formattedDate,
      editAvailabilityDayOfWeek: [dayOfWeek]
    }, () => this.renderAvailabilityList())


  }

  renderBody() {
    const _this = this;

    let monthstack, day, d, current, isDate, className;
    let weekstack = Array.apply(null, {length: 7}).map(Number.call, Number);
    let startDay = this.state.firstOfMonth.getUTCDay();
    let first = this.state.firstOfMonth.getDay();
    let rows = 5;
    let that = this;

    if(
      (startDay === 5 && this.state.daysInMonth === 31) ||
      (startDay === 6 && this.state.daysInMonth > 29)
    ) {
      rows = 6;
    }

    monthstack = Array.apply(null, {length: rows}).map(Number.call, Number);

    day = this.state.startDay + 1 - first;

    while(day > 1) {
      day -= 7;
    }

    day -= 2;

    return(
      <tbody>
        {monthstack.map(function(key, i) {
          d = day + i * 7;

          if(first === 0) {
            d = day + (i + 1) * 7;
          }

          return(
            <tr key={i}>
              {weekstack.map(function(key, i) {
                d += 1;

                isDate = d > 0 && d <= that.state.daysInMonth;

                const dayOfWeek = i % 7;

                if(isDate) {
                  let past = false;
                  current = new Date(that.state.year, that.state.month, d);
                  className = current.toString() !== that.state.today._d.toString() ? 'calendar__day' : 'calendar__day calendar__day--today';

                  if(moment(current).isBefore(moment()) && className.indexOf('today') < 0) {
                    past = true;
                    className += ' calendar__day--past';
                  }

                  return(
                    <td key={i} className={className}>
                      <div>
                        <span className="calendar__day-number">{d}</span>

                        {_this.renderAvailabilities(d, dayOfWeek, past)}

                        {/*
                          Disabling exlusions until a later date

                          {_this.renderExclusions(d, dayOfWeek)}
                        */}
                      </div>
                    </td>
                  )
                }

                if(d < 1) {
                  let prevMonthLength = new Date(moment().year(), moment().month(), 0).getDate();
                  return (
                    <td
                      key={i}
                      className="calendar__day calendar__day--outside"
                    >
                      {prevMonthLength + d}
                    </td>
                  )
                } else {
                  return (
                    <td
                      key={i}
                      className="calendar__day calendar__day--outside"
                    >
                      {d - that.state.daysInMonth}
                    </td>
                  )
                }
              })}
            </tr>
          )
        })}
      </tbody>
    )
  }

  render() {
    const { translation } = this.props;

    return (
      <div className="calendar-wrap">
        <table className="calendar">
          <caption>
            <div className="calendar__month">
              <h4 className="calendar__month-name">
                {translation.month_names[this.state.month]} {this.state.year}
              </h4>

              <div className="calendar__btns">
                <button
                  className="btn--outline"
                  onClick={this.today}
                >
                  {translation.today}
                </button>

                <button
                  className="calendar__nav calendar__nav--prev"
                  onClick={this.prevMonth}
                >
                  <icons.iconChevronLeft />
                  <span className="meta">{translation.prev_month}</span>
                </button>

                <button
                  className="calendar__nav calendar__nav--next"
                  onClick={this.nextMonth}
                >
                  <icons.iconChevronRight />
                  <span className="meta">{translation.next_month}</span>
                </button>
              </div>

              {this.state.timeZone &&
                <h4 className="calendar__month-timezone">{translation.times_shown_in} {this.state.timeZone}</h4>
              }

              <ul className="calendar__tools">
                <li>
                  <Link
                    to={`/locations/schedule/${this.props.locationSid}/calendar/${this.props.calendarSid}`}
                    onClick={() => this.props.setStep(2)}
                  >
                    {translation.edit}
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/locations/schedule/${this.props.locationSid}`}
                    onClick={() => this.props.setStep(1)}

                  >
                    {translation.all}
                  </Link>
                </li>
              </ul>
            </div>
          </caption>

          <thead>
            <tr>
              {translation.day_names.map(
                (key, i) =>
                <th
                  key={i}
                  scope="col"
                  className="calendar__weekday"
                >
                  <abbr title={translation.day_names[i]}>{key}</abbr>
                </th>
              )}
            </tr>
          </thead>

          {this.renderBody()}
        </table>

        {this.state.editAvailability &&
          <div className="calendar__popup-wrap">
            <div className="calendar__popup">

              <CustomAvailability
                  {...this.props}
                  cleanedAvailabilities={this.state.cleanedAvailabilities}
                  date={this.state.editAvailabilityDate}
                  dayOfWeek={this.state.editAvailabilityDayOfWeek}
                  parent={this}
                  callback={() => {
                    this.getAvailability()
                  }}
                  closeView={() => {
                    this.setState({editAvailability: false})
                  }}
              />

            </div>
          </div>
        }
      </div>
    )
  }
})

export default translate('CalendarView')(CalendarView);



// WEBPACK FOOTER //
// ./src/app/components/Schedule/CalendarView.js